import angular from 'angular';
import specificActListModule from './specific-act-list/specific-act-list';
import routinesListModule from './routines-list/routines-list';
import routinesDetailModule from './routines-detail/routines-detail';
import proceedingsListModule from './proceedings-list/proceedings-list';
import documentsListModule from './documents-list/documents-list';
import prqsListModule from './pqrs-list/pqrs-list';
import taskListModule from './task-list/task-list';

import consultCrmComponent from './consult-crm.component.js';
import consultCrmConfig from './consult-crm.config.js';

let consultCrmModule = angular.module('app.consultCrm',[
  specificActListModule.name,
  routinesListModule.name,
  routinesDetailModule.name,
  proceedingsListModule.name,
  documentsListModule.name,
  prqsListModule.name,
  taskListModule.name
])
.component("consultCrm",consultCrmComponent)
.config(consultCrmConfig);

export default consultCrmModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/consult-crm.js
 **/